// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bec_a bht_b bht_tu bht_qz bht_ra bht_uo","PanelFooter--link":"bec_b"};